import styled from 'styled-components';
import { ampli } from '../../../ampli';
import { Icon } from '../../../components/common/icon/Icon';
import { postMessageToRN } from '../../../utils/RNCommunicator/postMessageToRN.util';

export const RequestConsultSection = () => {
  const handlePluvaAutoInquiryButton = () => {
    ampli.오토최저가문의버튼클릭();
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'link', messageParam: 'tel:15335502' });
    } else {
      window.location.href = 'tel:15335502';
    }
  };

  return (
    <Container>
      <TopSection>
        <Title>{'앞서가는 농업인들이 먼저\n인정한 농기계 자율 주행 키트\n플루바 오토!'}</Title>
        <SubTitle>
          {
            '농기계 자율 주행 교육과 시연회가\n전남, 전북, 충남, 경북 지역에서 폭증하고 있어요!\n구매 · 교육 · 시연회 등 지금 바로 문의하세요.'
          }
        </SubTitle>
      </TopSection>
      <BottomSection>
        <Button onClick={handlePluvaAutoInquiryButton}>
          <ButtonMainTextWrapper>
            <Icon name={'PhoneWhite'} width={20} height={20} />
            <ButtonMainText>{'1533-5502'}</ButtonMainText>
          </ButtonMainTextWrapper>
          <ButtonSubText>{'클릭하고 최저가 문의'}</ButtonSubText>
        </Button>
      </BottomSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 48px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;

  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  white-space: pre-line;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */
`;

const SubTitle = styled.h3`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Body/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
`;

const BottomSection = styled.div`
  display: flex;
  padding: 0px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  border-radius: var(--radius-none, 0px);
`;

const HorizontalLine = styled.hr`
  width: 100%;

  height: 0px;
  align-self: stretch;
  stroke-width: 1px;
  stroke: #e4e4ed;
`;

const ImageButton = styled.img`
  width: 197px;
  height: 81px;
  cursor: pointer;
`;

const Button = styled.button`
  display: flex;
  padding: var(--radius-large, 16px) 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;

  border-radius: var(--radius-medium, 8px);
  background: linear-gradient(100deg, #34c77e 0%, #289668 100.49%, #2ca670 100.5%);

  cursor: pointer;
`;

const ButtonMainTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);
`;

const ButtonMainText = styled.h4`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */
`;

const ButtonSubText = styled.h5`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
`;
